import { loadRuntimeConfig } from '../runtimeConfig'

// Load configuration before importing modules that construct API clients or initialize Facebook.
loadRuntimeConfig().then(() => import('../bootstrap')).catch(() => {
    const root = document.getElementById('root')!
    const message = document.createElement('p')
    message.textContent = 'Could not load sign-in settings. Check your connection and try again.'
    const retry = document.createElement('button')
    retry.textContent = 'Try again'
    retry.onclick = () => window.location.reload()
    root.replaceChildren(message, retry)
})
